import { DashboardT } from 'business/definitions';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { useDispatch } from 'store/hooks';

/**
 * Update the full width attribute of a dashboard updates the full width value on success.
 * @param {DashboardT["key"]} dashboardKey - The key of the dashboard to update the filter in.
 */
const useUpdateDashboardWidth = (
    dashboardKey: DashboardT['key'],
    dashboardSlug: DashboardT['slug'],
) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['updateDashboardWidth', dashboardKey],

        mutationFn: async (payload: { is_full_width: boolean }) => {
            const response = await RQAPICallWithData<
                Pick<DashboardT, 'isFullWidth'>
            >({
                endpoint: `explore/dashboard/${dashboardKey}/is_full_width`,
                method: 'PATCH',
                body: payload,
            });
            return response.content.data;
        },

        onSuccess: (data) => {
            queryClient.setQueryData(
                ['getDashboard', dashboardSlug, ''],
                (oldDashboard: DashboardT) => {
                    return {
                        ...oldDashboard,
                        isFullWidth: data.isFullWidth,
                    };
                },
            );
        },

        onError: (error: Error) => {
            dispatch.vision.notifyUser({
                message: error.message,
                snackType: 'error',
            });
        },
    });
};

export default useUpdateDashboardWidth;
